export default "/assets/website/images/st5.jpg?ae6d2c004eba279cd648eb50597e2318";